import { useEffect, useState } from "react";
import { IdentificationCard, DownloadSimple } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../lib/api";

export default function TempBadgeCard({ uid, hasBadges }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!uid) return;
    api.get(`/employees/${uid}/badges`).then((r) => setVisible((r.data.badges || []).length > 0)).catch(() => setVisible(false));
  }, [uid, hasBadges]);

  if (!visible) return null;

  const download = async (fmt) => {
    try {
      const r = await api.get(`/users/${uid}/temporary-badge`, { params: { fmt }, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `temporary-badge.${fmt}`;
      a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("No badge on file yet — the office makes the first one"); }
  };

  return (
    <div className="mt-6 rounded-xl border border-stone-200 bg-white p-6 shadow-sm" data-testid="temp-badge-card">
      <div className="flex items-center gap-2">
        <IdentificationCard size={18} className="text-primary" />
        <p className="font-heading text-base font-bold text-stone-900">Lost your badge?</p>
      </div>
      <p className="mt-1 text-sm text-stone-500">
        Download a temporary badge marked <span className="font-semibold text-[#C0392B]">TEMPORARY</span> (good for 14 days).
        Print it and carry it — or if you can't print, keep it on your phone to show — until the office prints your replacement.
      </p>
      <div className="mt-3 flex gap-3">
        <button onClick={() => download("png")} className="inline-flex items-center gap-1 rounded-full border border-stone-300 px-3 py-1.5 text-xs font-medium text-stone-700 hover:bg-stone-900 hover:text-white" data-testid="temp-badge-png">
          <DownloadSimple size={13} /> PNG (keep on phone)
        </button>
        <button onClick={() => download("pdf")} className="inline-flex items-center gap-1 rounded-full border border-stone-300 px-3 py-1.5 text-xs font-medium text-stone-700 hover:bg-stone-900 hover:text-white" data-testid="temp-badge-pdf">
          <DownloadSimple size={13} /> PDF (print)
        </button>
      </div>
    </div>
  );
}
